// extracted by mini-css-extract-plugin
module.exports = {"megaMenuScrollStyle":"megaMenu_megaMenuScrollStyle__og6_h"};